import React from "react";
import { Link } from "react-router-dom";

const AppVideos = () => {
  const videos = [
    { id: "m3v3PN5bvZo", title: "Power Walking Workout" },
    { id: "vbJxymW5xj0", title: "Full Body Home Workout" },
    { id: "rKDoGD1-fgI", title: "Burn Arm + Leg + Belly Fat Workout" },
    { id: "QvE69Q1ugFU", title: "Full Body Workout" },
    { id: "snoKledrPo0", title: "Cardio Workout" },
    { id: "M0uO8X3_tEA", title: "Full Body Cardio Workout" },
  ];

  return (
    <section id="h4-pricing" className="relative w-full overflow-hidden">
      <div className="w-full h4-pricing-wrapper max-md:px-[30px] pb-[40px] md:pb-[80px] max-md:pt-[30px] md:pt-[80px] pricing_section_bg">
        <div className="container mx-auto px-0 relative z-20">
          {/* Videos Start Here */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map((video, index) => (
              <div
                key={index}
                className="video-card bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 w-full"
              >
                <div
                  className="relative w-full block"
                  style={{ paddingTop: "56.25%" }}
                >
                  <iframe
                    className="absolute inset-0 w-full h-full block"
                    src={`https://www.youtube.com/embed/${video.id}?rel=0`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
                <div className="p-5">
                  <h3 className="text-[14px] font-sora font-semibold text-secondary capitalize m-0">
                    {video.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
          {/* Videos End Here */}
        </div>

        <div className="shape-1 absolute left-40 top-96 z-0 pointer-events-none">
          <img src="assets/images/home-four/shape-1.webp" alt="" />
        </div>
        <div className="shape-2 absolute right-96 top-96 z-0 pointer-events-none">
          <img src="assets/images/home-four/shape-2.webp" alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-0 pointer-events-none">
          <img src="assets/images/home-four/shape-3.webp" alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-0 pointer-events-none">
          <img src="assets/images/home-four/shape-4.webp" alt="" />
        </div>
      </div>
    </section>
  );
};

export default AppVideos;